"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = RemoveCircle;

var _RemoveCircle = require("@adobe/react-spectrum-workflow/dist/RemoveCircle.js");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function RemoveCircle(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_RemoveCircle.A4uRemoveCircle, null));
}